import { useQuery } from 'react-query';
import axios from 'axios';

const useGet = ({
  queryKey,
  api,
  options = {},
  method = 'get',
  data,
  config
}) => {
  const result = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const response = await axios[method](
          `${process.env.REACT_APP_API_BASE_URL}/${api}`,
          data,
          config
      );

      if (!response?.data?.success) {
        throw new Error('Terjadi kesalahan di server!');
      }

      return response.data;
    },
    refetchOnWindowFocus: false,
    ...options
  });

  return {
    ...result,
    data: result?.data?.data,
    statusCode: result?.data?.status,
    dataPages: result?.data?.pages
  };
};

export default useGet;
